import env from '@/config/env'
import { create } from '@educabot/cloud-client'

export const client = create(env.BASE_URL)
export const { lms, web, org } = client
